import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class TechnicianClockingProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetTechnicianClockingReport(Parameters: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetTechnicianClockingReport?${Parameters}&ColumnSequence=${columnsSeq}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new TechnicianClockingProvider();
